module.exports = __webpack_public_path__ + "static/media/dailyRoutine_2_zh_HK.22510f3e.png";